import classes from "./MoreSeatsRadioButton.module.scss";

const MoreSeatsRadioButton = ({ text, onChangeSeats }) => {
  return (
    <div className={classes.BookingRadioButton}>
      <input
        id={text}
        type="radio"
        name="bookingSeats"
        onChange={() => onChangeSeats(text)}
      />
      <label htmlFor={text}>{text}</label>
    </div>
  );
};

export default MoreSeatsRadioButton;
